import { baseApi as api } from "../baseApi";
const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    getV2ProviderSchedulingManage: build.query<
      GetV2ProviderSchedulingManageApiResponse,
      GetV2ProviderSchedulingManageApiArg
    >({
      query: () => ({ url: `/v2/provider/scheduling/manage` }),
    }),
    putV2ProviderSchedulingManage: build.mutation<
      PutV2ProviderSchedulingManageApiResponse,
      PutV2ProviderSchedulingManageApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/scheduling/manage`,
        method: "PUT",
        body: queryArg.setManageRequest,
      }),
    }),
    deleteV2ProviderSchedulingManageByPolicyId: build.mutation<
      DeleteV2ProviderSchedulingManageByPolicyIdApiResponse,
      DeleteV2ProviderSchedulingManageByPolicyIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/scheduling/manage/${queryArg.policyId}`,
        method: "DELETE",
      }),
    }),
  }),
  overrideExisting: false,
});
export { injectedRtkApi as enhancedApi };
export type GetV2ProviderSchedulingManageApiResponse =
  /** status 200 OK */ ManageConfigListResponse;
export type GetV2ProviderSchedulingManageApiArg = void;
export type PutV2ProviderSchedulingManageApiResponse =
  /** status 200 OK */ ManageConfigResponse;
export type PutV2ProviderSchedulingManageApiArg = {
  setManageRequest: SetManageRequest;
};
export type DeleteV2ProviderSchedulingManageByPolicyIdApiResponse =
  /** status 200 OK */ ManageConfigListResponse;
export type DeleteV2ProviderSchedulingManageByPolicyIdApiArg = {
  policyId: string;
};
export type ManageConfigSchema = {
  cancel_enabled?: boolean;
  /** Null = org-wide; set = per-encounter-type override. */
  encounter_type_id?: string | null;
  minimum_notice_hours: number;
  policy_id: string;
  reschedule_enabled?: boolean;
  title?: string | null;
};
export type ManageConfigListResponse = {
  /** The window that applies when the org has no config (24). */
  default_notice_hours: number;
  items: ManageConfigSchema[];
  total: number;
};
export type ValidationErrorElement = {
  ctx?: object;
  loc: string[];
  msg: string;
  type: string;
};
export type ValidationError = ValidationErrorElement[];
export type ManageConfigSchema2 = {
  cancel_enabled?: boolean;
  /** Null = org-wide; set = per-encounter-type override. */
  encounter_type_id?: string | null;
  minimum_notice_hours: number;
  policy_id: string;
  reschedule_enabled?: boolean;
  title?: string | null;
};
export type ManageConfigResponse = {
  config: ManageConfigSchema2;
};
export type ClientErrorResponse = {
  /** The error code for the error */
  error_code?: string;
  /** The message for the error */
  message?: string;
  /** The HTTP status code for the client error */
  status?: number;
};
export type SetManageRequest = {
  /** Whether patients may self-cancel at all. */
  cancel_enabled?: boolean;
  /** Omit/null for the org-wide window. */
  encounter_type_id?: string | null;
  minimum_notice_hours: number;
  /** Whether patients may self-reschedule at all. */
  reschedule_enabled?: boolean;
};
